import React__default, { useState } from 'react';
import { TextField, CurrencyField, Button } from '@deal/components';
import { useChatContext } from '../../../../containers/ChatContext/index.js';
import { ToastNotificationType } from '../../../../typings/index.js';
import { PaymentVerificationMethod } from '../../../../generated/types.js';
import numeral from 'numeral';
import { VerifyPaymentTransactionComponent } from './VerifyPaymentTransaction.generated.js';
import PrivacyIcon from './privacy.svg.js';
import styles from './styles.css.js';

var PaymentVerificationForm = function PaymentVerificationForm(_a) {
  var orderId = _a.orderId,
      transactionId = _a.transactionId,
      formClassName = _a.formClassName,
      codeInputClassName = _a.codeInputClassName,
      verificationMethod = _a.verificationMethod;
  var chatContext = useChatContext();

  var _b = useState(''),
      code = _b[0],
      setCode = _b[1];

  var _c = useState(''),
      amount = _c[0],
      setAmount = _c[1];

  return React__default.createElement(VerifyPaymentTransactionComponent, {
    variables: {
      input: {
        orderId: orderId,
        transactionId: transactionId,
        code: PaymentVerificationMethod.CODE ? code : null,
        amount: verificationMethod === PaymentVerificationMethod.AMOUNT ? {
          currency: 'USD',
          amount: numeral(amount).format('0.00')
        } : null
      }
    },
    onCompleted: function onCompleted(response) {
      if (response && response.verifyPaymentTransaction) {
        if (response.verifyPaymentTransaction.verified) {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(ToastNotificationType.SUCCESS, 'Payment verified successfully!');
        } else if (response.verifyPaymentTransaction.error) {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(ToastNotificationType.ERROR, "Payment verification failed: " + response.verifyPaymentTransaction.error);
        } else {
          (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(ToastNotificationType.ERROR, "Payment verification failed!");
        }
      }
    },
    onError: function onError() {
      (chatContext === null || chatContext === void 0 ? void 0 : chatContext.onToastNotification) && chatContext.onToastNotification(ToastNotificationType.ERROR, 'Error verifying your payment! Please try again.');
    }
  }, function (verifyPayment, _a) {
    var loading = _a.loading;
    return React__default.createElement("form", null, React__default.createElement("div", {
      className: formClassName
    }, React__default.createElement("div", {
      className: codeInputClassName
    }, verificationMethod === PaymentVerificationMethod.CODE ? React__default.createElement(TextField, {
      value: code,
      label: "",
      labelHidden: true,
      onChange: function onChange(e) {
        return setCode(e.target.value);
      },
      placeholder: "Verification code"
    }) : React__default.createElement(CurrencyField, {
      label: "Verification Amount",
      labelHidden: true,
      value: amount,
      placeholder: "Verification amount",
      onChange: function onChange(e) {
        return setAmount(e.target.value);
      }
    })), React__default.createElement(Button, {
      onClick: function onClick() {
        return verifyPayment();
      },
      disabled: code === '' && amount === '' || loading
    }, React__default.createElement(PrivacyIcon, {
      className: styles.privacyIcon
    }), " Submit")));
  });
};

export default PaymentVerificationForm;
//# sourceMappingURL=index.js.map
